export default __webpack_public_path__ + "static/media/PAQUETEXPRESS.02c5ebc3.svg";